<template>
  <div class="background-color-white mb-3">
    <Title
      v-if="!isRedeemable()"
      :category="product.categories[0]"
      :department="product.parent_categories[0]"
      class="pl-5"
    />
    <RouteBack v-if="!isRedeemable()" class="pl-5" />
    <RedeemInStoreDialog
      v-if="isRedeemable()"
      :product="product"
      :dialog="dialog"
      :close="closeDialog"
    />
    <v-row
      v-if="isRedeemable()"
      class="background-secondary-color fill-height mb-5"
      align="center"
      justify="center"
      ><v-col cols="1" class="pl-5">
        <v-icon @click="$router.go(-1)" color="white"
          >mdi-arrow-left</v-icon
        > </v-col
      ><v-col cols="11" class="pt-5 pl-0 text-center">
        <span class="color-white redeem-reward">Redeem reward</span><br />
        <span v-if="product.redemption_points_offer" class="my-balance"
          >My Balance:
        </span>
        <span v-if="product.redemption_points_offer" class="color-white points">
          {{ total_points_remaining }} points</span
        >
      </v-col></v-row
    >
    <v-container>
      <v-row class="px-2 mt-3">
        <v-col cols="3" :class="{ 'confetti-left': isRedeemable() }"></v-col>
        <v-col
          cols="6"
          class="d-flex justify-center overflow-hidden position-relative"
        >
          <CornerRibbon
            v-if="showRibbon()"
            :newItem="
              !(
                product.pricebook_info.promotions &&
                product.pricebook_info.promotions.length
              )
            "
            large
          />
          <div class="align-center d-flex justify-center">
            <img
              v-if="product.image"
              :alt="product.name"
              :src="product.image"
              class="modifier-product-image-size"
            />
            <NoImageAvailable
              v-else
              :departmentName="
                getProductDepartmentName(
                  product.parent_categories,
                  product.categories,
                )
              "
              :size="'md'"
            />
          </div>
        </v-col>
        <v-col cols="3" :class="{ confetti: isRedeemable() }"></v-col>
      </v-row>

      <v-row
        class="background-color-white px-3 py-3"
        :class="{ fixed }"
        :style="fixed && rewardsFormat ? 'top: 70px' : ''"
      >
        <v-col>
          <v-row class="mb-3" no-gutters>
            <v-col
              cols="12"
              class="d-flex align-center justify-space-between line-height-1"
            >
              <div class="font-size-lg font-weight-semibold" ref="fixRef">
                {{ product.name }}
              </div>
              <FavoriteIcon :upc="product.upc" mobile />
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col class="line-height-1">
              <div class="color-suva-grey font-size-xs" v-if="!isRedeemable()">
                Starting at
              </div>
              <UnitPriceDisplay
                :byweight="product.byweight"
                :loyalty="product.loyalty"
                :points="product.redemption_points_offer"
                :redeemable="product.redeemable"
                :type="'modifier'"
                :unitPrice="product.cents"
              />
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <v-row :class="{ 'margin-for-fixed-header': fixed }">
        <v-col>
          <v-row>
            <v-col>
              <v-row
                class="border-top"
                v-for="modifierGroup in product.modifierGroups"
                :key="modifierGroup.modifier_group"
              >
                <v-col cols="12" class="background-color-seashell px-5 py-5">
                  <div
                    class="font-size-sm"
                    :class="!modifierGroup.valid ? 'color-fire-engine-red' : ''"
                  >
                    {{ getModifierGroupHeaderText(modifierGroup) }}
                  </div>
                  <div class="color-suva-grey font-size-xs">
                    {{ getModifierGroupRequirementsText(modifierGroup) }}
                  </div>
                </v-col>
                <v-col class="py-3 px-5">
                  <table>
                    <tbody>
                      <tr
                        v-for="modifier in getModifiers(
                          modifierGroup.modifiers,
                        )"
                        :key="`${modifierGroup.modifier_group}${modifier.upc}`"
                      >
                        <td class="pr-9 py-2">
                          <CheckboxInput
                            :countCheckedModifiers="countCheckedModifiers"
                            :handleModifierSelect="handleModifierSelect"
                            :modifier="modifier"
                            :modifierGroup="modifierGroup"
                            :modifiers="product.modifiers"
                            sm
                          />
                        </td>
                        <td>
                          <span
                            v-if="modifier.cents"
                            class="font-size-sm text-center"
                            >{{ formatCurrency(modifier.cents) }}</span
                          >
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </v-col>
              </v-row>
            </v-col>
          </v-row>

          <v-row class="background-color-seashell border-top px-5 pb-3">
            <v-col>
              <v-row align="center" class="mt-0" v-if="!rewardsFormat">
                <v-col cols="5">
                  <div
                    class="d-flex"
                    :color="product.qty ? 'primary' : 'secondary'"
                  >
                    <v-btn
                      @click.stop="less"
                      :disabled="disableMinusBtn()"
                      fab
                      small
                    >
                      <v-icon>mdi-minus</v-icon>
                    </v-btn>
                    <div
                      class="align-center d-flex justify-center quantity-display-width font-size-sm"
                    >
                      {{ product.qty }}
                    </div>
                    <v-btn
                      @click.stop="more"
                      fab
                      small
                      :disabled="disableMore()"
                    >
                      <v-icon>mdi-plus</v-icon>
                    </v-btn>
                  </div>
                </v-col>
                <v-col cols="7">
                  <div @click.stop="update">
                    <v-btn
                      color="success"
                      height="48"
                      :disabled="!readyToAddToCart"
                      block
                    >
                      <div
                        class="d-flex full-width justify-space-between font-size-sm font-weight-semibold text-capitalize"
                      >
                        <span v-if="!isRedeemable()">{{
                          `${product.item_id ? "update in" : "add to"} cart`
                        }}</span>
                        <span v-else>Redeem</span>
                        <span v-if="product.redemption_points_offer_id"
                          >{{
                            product.redemption_points_offer * product.qty
                          }}
                          Points</span
                        >
                        <span v-if="product.is_redemption">Free</span>
                        <span v-if="!product.redeemable"
                          >+{{ formatCurrency(price) }}</span
                        >
                      </div>
                    </v-btn>
                  </div>
                </v-col>
              </v-row>
              <v-row v-if="isRedeemable()">
                <v-col>
                  <div class="text-center">
                    <v-btn
                      color="secondary"
                      dark
                      block
                      large
                      class="px-8"
                      @click="dialog = true"
                    >
                      <Icon
                        class="mt-1"
                        name="qr_scan"
                        :color="'white'"
                        :style="{
                          height: '25px',
                          width: '25px',
                          'vertical-align': 'inherit',
                        }"
                      ></Icon>
                      <span
                        class="font-size-sm font-weight-bold text-none text-center"
                        >Redeem in Store</span
                      >
                    </v-btn>
                  </div>
                </v-col>
              </v-row>
              <v-row
                v-if="
                  product.pricebook_info.promotions &&
                  product.pricebook_info.promotions.length
                "
              >
                <v-col>
                  <TermsList
                    v-if="
                      !product.loyalty &&
                      product.pricebook_info.promotions &&
                      product.pricebook_info.promotions.length
                    "
                    :byweight="product.byweight"
                    :promotions="product.pricebook_info.promotions"
                  />
                  <!-- termslist has a block option that looks real nice -->
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row
            v-if="hasTieredDiscount"
            class="font-size-xs grey--text justify-center"
            no-gutters
          >
            *Tiered discounts cannot be combined with the other tiered discounts
            for this item.
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import throttle from "lodash.throttle";
import {
  checkModifierGroupValidity,
  formatCurrency,
  getEstimatedPrice,
  getModifierGroupHeaderText,
  getModifierGroupRequirementsText,
  getProductDepartmentName,
} from "@/util.js";
import CheckboxInput from "@/components/Inputs/Checkbox.vue";
import FavoriteIcon from "@/components/Product/FavoriteIcon.vue";
import NoImageAvailable from "@/components/Product/NoImageAvailable.vue";
import CornerRibbon from "@/components/Product/Promotions/CornerRibbon.vue";
import RouteBack from "@/components/UI/RouteBack.vue";
import TermsList from "@/components/Product/Promotions/Terms/List.vue";
import Title from "@/components/Product/Title.vue";
import UnitPriceDisplay from "@/components/Product/UnitPriceDisplay.vue";
import Icon from "@/components/UI/Icon.vue";
import RedeemInStoreDialog from "../Dialogs/RedeemInStore.vue";

function initialState() {
  return {
    added: 0,
    dialog: false,
    fixed: false,
    readyToAddToCart: false,
    sufficientQuantity: false,
  };
}

export default {
  name: "ProductModifiersView",
  components: {
    CheckboxInput,
    FavoriteIcon,
    Icon,
    NoImageAvailable,
    CornerRibbon,
    RouteBack,
    RedeemInStoreDialog,
    TermsList,
    Title,
    UnitPriceDisplay,
  },
  computed: {
    ...mapGetters("store", {
      rewardsFormat: "rewardsFormat",
      total_points_remaining: "total_points_remaining",
      club_free_products_qty_remaining: "club_free_products_qty_remaining",
    }),
    ...mapGetters({
      hasTieredDiscount: "product/hasTieredDiscount",
      missingModifiers: "product/missingModifiers",
    }),
    price() {
      return this.getEstimatedPrice(this.product);
    },
  },
  created() {
    document.addEventListener("scroll", this.handleScroll);
    this.$store.commit("product/INITIALIZE_QTY");
  },
  data() {
    return initialState();
  },
  destroyed() {
    document.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    countCheckedModifiers(modifierGroup) {
      /*
        need to know how many picked (checked) modifiers.upc
        are in the group (modifiersInGroup) array of objects
      */
      return this.product.modifiers.filter(
        (modifier) =>
          modifier.modifier_group === modifierGroup.modifier_group &&
          modifierGroup.modifiers.some((m) => m.upc === modifier.upc),
      ).length;
    },
    closeDialog() {
      this.dialog = false;
    },
    formatCurrency,
    getEstimatedPrice,
    getModifierGroupHeaderText,
    getModifierGroupRequirementsText,
    getProductDepartmentName,
    async handleModifierSelect(event, modifier) {
      const checked = event.target.checked;

      // this manages selected modifiers on this product (product.modifiers)
      await this.$store.dispatch("product/handleModifierSelect", {
        checked,
        modifier,
      });

      this.verifyReadyToAddToCart();
    },
    disableMore() {
      return (
        (this.product.redeemable &&
          this.total_points_remaining -
            this.product.redemption_points_offer *
              (this.added + (this.product.item_id ? 0 : 1)) <
            this.product.redemption_points_offer) ||
        this.club_free_products_qty_remaining(this.product.club_id) -
          this.product.qty <
          1
      );
    },
    handleScroll: throttle(function () {
      const fixRef = this.$refs.fixRef;
      const fixRefPosition = Math.round(fixRef.getBoundingClientRect().top);
      this.fixed = window.pageYOffset > fixRefPosition;
    }, 200),
    getModifiers(modifiers) {
      return this.isRedeemable()
        ? modifiers.filter((m) => m.cents === 0)
        : modifiers;
    },
    hasMissingModifiers() {
      let modifierGroups = this.product.modifierGroups.map((group) => {
        const totalCheckedInGroup = this.countCheckedModifiers(group);
        return {
          ...group,
          valid: checkModifierGroupValidity(group, totalCheckedInGroup),
        };
      });
      this.$store.commit(
        "product/UPDATE_PRODUCT_MODIFIER_GROUPS",
        modifierGroups,
      );
    },
    isRedeemable() {
      return !!this.product.redeemable;
    },
    less() {
      if (this.product.qty === 0) return;
      this.added -= 1;
      this.$store.commit("product/LESS_QTY");
      this.verifyReadyToAddToCart();
    },
    more() {
      this.added += 1;
      this.$store.commit("product/MORE_QTY");
      this.verifyReadyToAddToCart();
    },
    update() {
      this.verifyReadyToAddToCart();
      if (!this.readyToAddToCart) return;

      this.$store.dispatch(
        "cart/updateModifierProductFromServerResponse",
        this.product,
      );

      this.routeBackAfterUpdate();
    },
    routeBackAfterUpdate() {
      /*
       * need to go back 2 in case of coming from addFromCart
       * otherwise 1
       */

      const back = { one: -1, two: -2 };
      const comingFromAddFromCartView =
        this.$route.params.from === "addFromCart";
      const goBack = comingFromAddFromCartView ? back.two : back.one;
      this.$router.go(goBack);
    },
    showRibbon() {
      return (
        !this.isRedeemable() &&
        ((this.product.pricebook_info.promotions &&
          this.product.pricebook_info.promotions.length) ||
          this.product.new_product)
      );
    },
    verifyReadyToAddToCart() {
      this.hasMissingModifiers();
      this.verifySufficientQuantity();
      this.readyToAddToCart = this.sufficientQuantity && !this.missingModifiers;
    },
    verifySufficientQuantity() {
      this.sufficientQuantity = this.product.qty > 0;
    },
    disableMinusBtn() {
      if (
        (this.product.byweight && this.product.qty < 1) ||
        (!this.product.byweight && this.product.qty < 2)
      ) {
        return true;
      }
      return false;
    },
  },
  mounted() {
    this.verifyReadyToAddToCart();
  },
  props: {
    product: Object,
  },
};
</script>

<style scoped>
.fixed {
  position: fixed;
  top: 173px;
  width: 100%;
  z-index: 1;
}

.margin-for-fixed-header {
  margin-top: 80px;
}

.modifier-product-image-size {
  border-radius: 4px;
  height: 223px;
  max-width: 100%;
}
.confetti-left {
  background-image: url("~@/assets/Confetti_Left.svg");
  background-repeat: repeat-y;
}
.confetti {
  background-image: url("~@/assets/Confetti.svg");
  background-repeat: repeat-y;
}
</style>
